/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:36:13
 * @LastEditTime: 2023-02-17 15:36:34
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\basic-content-manage\modules\contentManageRouter.js
 * 内容管理
 */
import { getAuthClientList } from '@/api/common'
import store from '@/store'
const contentManageRouter = [
  // 费控系统 产品价格信息列表
  {
    path: '/costControlSystem/basics/goods-page',
    name: 'costControlSystemGoodsPage',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/basics/goods/goodsPage.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '产品价格信息',
    },
  },
  // 费控系统 产品价格信息列表 编辑产品价格信息
  {
    path: '/costControlSystem/basics/goods-edit/:goods_id',
    name: 'costControlSystemGoodsEdit',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/basics/goods/edit.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '编辑产品价格信息',
      breadcrumb: [
        {
          title: '产品价格信息',
          name: 'costControlSystemGoodsPage',
        },
      ],
    },
  },
  // 费控系统 终端价格备案列表
  {
    path: '/costControlSystem/priceRecord/priceRecordList',
    name: 'costControlSystemPriceRecord',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/priceRecord/price/priceRecordPage.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '终端价格备案',
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 费控系统 终端价格备案列表 编辑终端价格备案
  {
    path: '/costControlSystem/priceRecord/price-record-edit/:cost_terminal_price_id',
    name: 'costControlSystemPriceRecordEdit',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/priceRecord/price/priceRecordEdit.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '新增终端价格备案',
      breadcrumb: [
        {
          title: '终端价格备案',
          name: 'costControlSystemPriceRecord',
        },
      ],
    },
  },
  // 费控系统 导入终端备案
  {
    path: '/costControlSystem/priceRecord/priceRecordOut',
    name: 'costControlSystemPriceOut',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/priceRecord/price/priceRecordOut.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '导入终端备案',
      breadcrumb: [
        {
          title: '终端价格备案',
          name: 'costControlSystemPriceRecord',
        },
      ],
    },
  },
  // 费控系统 内容管理 药品价格备案
  {
    path: '/costControlSystem/priceRecord/drug-price-record',
    name: 'costControlSystemPriceRecordDrugPriceRecord',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/priceRecord/drugPriceRecord/index.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '药品价格备案',
    },
  },
  // 费控系统  内容管理 药品价格备案 添加编辑
  {
    path: '/costControlSystem/priceRecord/drug-price-record/add-edit/:cost_drug_price_record_id',
    name: 'costControlSystemPriceRecordDrugPriceRecordAddEdit',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/priceRecord/drugPriceRecord/addEdit.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '新增药品价格备案',
      breadcrumb: [
        {
          title: '药品价格备案',
          name: 'costControlSystemPriceRecordDrugPriceRecord',
        },
      ],
    },
  },
  // 费控系统 财务出纳 付款款账户管理
  {
    path: '/costControlSystem/finance/pay-account',
    name: 'costControlSystemPayAccount',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/finance/payAccount/index.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '付款账户管理',
    },
    //  beforeEnter(to, from, next) {
    //   getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
    //     if (0 === res.status) {
    //       let classList = res.data.classList
    //       store.commit('setClientClassList', classList)
    //     }
    //     next()
    //   })
    // },
  },
  // 费控系统 财务出纳 收款账户管理
  {
    path: '/costControlSystem/finance/collection-account',
    name: 'costControlSystemCollectionAccount',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/finance/collectionAccount/index.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '收款账户管理',
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 费控系统 财务出纳 收款账户管理 导入收款账户
  {
    path: '/costControlSystem/finance/collection-account-import',
    name: 'costControlSystemCollectionAccountImport',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/finance/collectionAccount/importAccount.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '导入收款账户',
      breadcrumb: [
        {
          title: '收款账户管理',
          name: 'costControlSystemCollectionAccount',
        },
      ],
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 费控系统 财务出纳 收款账户管理 收款账户详情
  {
    path: '/costControlSystem/finance/collection-account-detail/:type/:id',
    name: 'costControlSystemCollectionAccountDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/finance/collectionAccount/detail.vue'
      ),
    meta: {
      SecondaryMenu: '内容管理', //二级菜单
      title: '收款账户详情',
      breadcrumb: [
        {
          title: '收款账户管理',
          name: 'costControlSystemCollectionAccount',
        },
      ],
    },
  },
]

export default contentManageRouter
